<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="20">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                             :size="GCONFIG.styleElFormSize">
                        <el-form-item label="团购名称">
                            <el-input v-model="formInline.groupName" maxlength="20" placeholder="团购名称"></el-input>
                        </el-form-item>
                        <el-form-item label="团状态">
                            <el-select v-model="formInline.isPrize" clearable filterable>
                                <el-option
                                        v-for="item in groupStatus"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="mini" @click="getList">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="success" size="mini" @click="newGroupHandle">开团</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>

        <el-table :data="joinList" stripe border center :size="GCONFIG.styleTableSize"  show-summary v-loading="loading">
            <el-table-column type="expand" label="序号" width="50">
                <template slot-scope="scope">
                    <el-form label-position="left"  class="demo-table-expand">
                        <el-form-item label="团购连接">
                            <span>{{ scope.row.link }}</span>
                        </el-form-item>
                        <el-form-item label="活动名称">
                            <span>{{ scope.row.activeName }}</span>
                        </el-form-item>
                        <el-form-item label="团购id">
                            <span>{{ scope.row.inviteId }}</span>
                        </el-form-item>
                        <el-form-item label="创建人">
                            <span>{{scope.row.creator}}</span>
                        </el-form-item>
                        <el-form-item label="提货地址">
                            <span>{{scope.row.address}}</span>
                        </el-form-item>

                    </el-form>
                </template>
            </el-table-column>
            <el-table-column prop="groupTypeName" label="团购类型" width="120"></el-table-column>
            <el-table-column prop="groupName" label="名称" width="170"></el-table-column>
            <el-table-column prop="groupOrderAmout" label="下单金额" width="120" sortable></el-table-column>
            <el-table-column prop="limitOrderAmout" label="最低下单金额" width="120">
                <template slot-scope="scope">
                    <span>{{scope.row.limitOrderAmout}}元</span>
                </template>
            </el-table-column>
            <el-table-column prop="limitSuccAmout" label="最低成团金额" width="120">
                <template slot-scope="scope">
                    <span>{{scope.row.limitSuccAmout}}元</span>
                </template>
            </el-table-column>
            <el-table-column prop="refundAmout" label="退款金额" width="120" sortable></el-table-column>
            <el-table-column prop="prizeTime" label="成团时间" width="120">
                <template slot-scope="scope">
                    <span>{{scope.row.isPrize==1&&scope.row.prizeTime!=null?scope.row.prizeTime:'-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <el-tag size="mini" v-if="scope.row.isPrize==0" type="danger" effect="plain">团购中</el-tag>
                    <el-tag size="mini" v-if="scope.row.isPrize==1&&scope.row.prizeTime==null" effect="plain">已关闭</el-tag>
                    <el-tag size="mini" v-if="scope.row.isPrize==1&&scope.row.prizeTime!=null" effect="plain">已成团</el-tag>
                    <el-tag size="mini" v-if="scope.row.isPrize==2" type="success" effect="plain">已退款</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="joiningCount" label="参团中人数">
            </el-table-column>
            <el-table-column prop="successCount" label="成团人数">
            </el-table-column>
            <el-table-column prop="createTime" label="开团时间"></el-table-column>
            <el-table-column label="操作" fixed="right" width="220px">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="primary" size="mini"
                                   @click="getInviteDetail(scope.row)">订单明细
                        </el-button>
                        <el-tooltip class="item" effect="dark" content="截单后团购关闭无法下单,加单点开启" placement="right">
                            <el-button type="success" v-show="scope.row.prizeTime==null" size="mini" @click="startOrEndGroup(scope.row)">
                                {{scope.row.isPrize==1?'开启':'截单'}}
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="成团操作不可撤销,执行成团操作会模板消息知用户成团了" placement="right">
                            <el-button type="danger" v-show="scope.row.prizeTime==null&&scope.row.isPrize==1" size="mini" @click="prize(scope.row)">
                                成团
                            </el-button>
                        </el-tooltip>
                        <!--<el-button type="primary" v-show="scope.row.prizeTime==null&&scope.row.isPrize==0" size="mini" @click="handleEdit(scope.row)">-->
                            <!--修改-->
                        <!--</el-button>-->
                        <el-button type="primary" size="mini" @click="handleEdit(scope.row)">
                            修改
                        </el-button>
                        <el-button type="info" size="mini" @click="getLinkList(scope.row)">
                            分销
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>

        <el-dialog title="订单明细" :visible.sync="showDialog">
            <div>
                <el-row :gutter="20">
                    <el-form :inline="true"  class="demo-form-inline select-wrap"
                             :size="GCONFIG.styleElFormSize">
                        <el-form-item>
                            <el-button type="success"  size="mini" @click="exportOrder()">导出有效订单</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
                <el-row :gutter="20">
                    <el-table :data="inviteList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
                        <el-table-column type="index" label="序号" width="50"></el-table-column>
                        <!--<el-table-column prop="activeName" label="活动名称" width="170"></el-table-column>-->
                        <el-table-column prop="headImageUrl" label="头像">
                            <template slot-scope="scope">
                                <el-avatar size="small" :src="scope.row.headImageUrl"></el-avatar>
                            </template>
                        </el-table-column>
                        <el-table-column prop="nickName" label="昵称">
                            <template slot-scope="scope">
                                <a :href="getLink(scope.row.customerId)" alt="点击查看用户详情"
                                   target="_blank">{{scope.row.nickName == null ? '无' : scope.row.nickName == '' ? '未关注用户' : scope.row.nickName}}</a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderMainNo" label="订单号" width="220">
                            <template slot-scope="scope">
                                <a :href="getOrderLink(scope.row.orderMainNo)" alt="点击查看订单"
                                   target="_blank">{{scope.row.orderMainNo}}</a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="活动参与时间" sortable></el-table-column>
                        <el-table-column prop="totalAmount" label="订单金额" sortable></el-table-column>
                        <el-table-column prop="status" label="状态" width="80" sortable  fixed="right">
                            <template slot-scope="scope">
                                <el-tag size="mini" v-if="scope.row.status==-1" effect="plain">未付款</el-tag>
                                <el-tag size="mini" v-if="scope.row.status==0" effect="plain">参团中</el-tag>
                                <el-tag size="mini" v-if="scope.row.status==1" type="success" effect="plain">已成团</el-tag>
                                <el-tag size="mini" v-if="scope.row.status==2" type="success" effect="plain">已退款</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
            </div>
        </el-dialog>
        <el-dialog title="开团" :visible.sync="showCreate">
            <el-form :model="form" :rules="rules" label-width="100px" class="demo-ruleForm">
                <el-form-item label="名称" required="true">
                    <el-input v-model="form.groupName" placeholder="团名称 30字以内 显示在用户参团页面" maxlength="30"></el-input>
                    <span>区-小区+团购   例:静安区-都市森林</span>
                </el-form-item>
                <el-form-item label="提货地址" required="true">
                    <el-input v-model="form.address" placeholder="地址 200字以内" maxlength="200"></el-input>
                    <span>e.g 省-市-区-路-号  详细地址 上海市徐汇区漕东支路100号漕溪二村</span>
                </el-form-item>
                <el-form-item label="最低成团金额" required="true">
                    <el-input v-model="form.limitSuccAmout" type="number" placeholder="满多少成团" maxlength="11"
                              clearable></el-input>
                </el-form-item>
                <el-form-item label="最低下单金额" required="true">
                    <el-input v-model="form.limitOrderAmout" type="number" placeholder="最低下单金额" maxlength="11"
                              clearable></el-input>
                </el-form-item>
                <el-form-item label="团状态" required="true" v-show="form.inviteId!=''&&form.prizeTime!=null">
                    <el-select v-model="form.isPrize"  clearable filterable>
                        <el-option
                                v-for="item in groupOnStatus"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="bindCode" v-show="false">
                    <el-input v-model="form.bindCode" type="number" placeholder="bindCode"
                              clearable></el-input>
                </el-form-item>
                <el-form-item label="团id" v-show="false">
                    <el-input v-model="form.inviteId"  placeholder="团id" maxlength="11"
                              clearable></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" size="mini" @click="saveGroup">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="分销连接" :visible.sync="showDistributorVo">
            <el-table :data="distributorVoList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="distributorName" label="分销员" width="150"></el-table-column>
                <el-table-column prop="link" label="分销连接"  fixed="right">
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getGrouponListApi, getInviteDetailApi, setGrouponPrizeApi, getGrouponDtailList, creatGroup,getLink,downloadJoinOrder
    } from '../../api/api';
    export default {
        data() {
            return {
                formInline: {
                    bindCode: this.$route.query.bindCode || "",
                    customerId: "",
                    start: '',
                    end: '',
                    groupType: '',
                    isPrize:0,
                    currentPage: 1,
                    orderMainNo: '',
                    groupName: '',
                    pageSize: 50,
                    recordsTotal: 0
                },
                form: {
                    "activeNo": '',
                    "inviteId":'',
                    "bindCode": this.$route.query.bindCode || '',
                    "orderType": 1,
                    "sourceType": 2,
                    "platformId": 4,
                    "groupType": 2,
                    "isPrize":0,
                    "limitOrderAmout": 100,
                    "address":'',
                    "limitSuccAmout": 4000,
                    "groupName": ''
                },
                loading: true,
                showDialog: false,
                showCreate: false,
                showDistributorVo:false,
                groupOnStatus: [{id:0,name:'开启'},{id:1,name:'关闭'}],
                joinList: [],
                groupStatus:[{id:0,name:'开团中'},{id:1,name:'已成团'},{id:4,name:'已关闭'}],
                inviteList: [],
                distributorVoList:[]
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList();
        },
        methods: {
            prize(row) {
                this.$prompt('请输入密码', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(({ value }) => {
                   if(value==='chengtuan'){
                       if(row.isPrize==1&&row.prizeTime!=null){
                           this.$message({
                               showClose: true,
                               message: '已成团',
                               type: 'error'
                           });
                           return;
                       }
                       this.$confirm('成团操作不可撤销, 是否继续?', '提示', {
                           confirmButtonText: '确定',
                           cancelButtonText: '取消',
                           type: 'warning'
                       }).then(() => {
                           //设置成团
                           this.loading = true;
                           setGrouponPrizeApi({'inviteId': row.inviteId}).then((res) => {
                               this.loading = false;
                               if (res.data.status == 200) {
                                   this.$message({
                                       message: '保存成功',
                                       type: 'success'
                                   });
                                   this.getList();
                               } else {
                                   this.$message({
                                       showClose: true,
                                       message: res.data.message,
                                       type: 'error'
                                   });
                               }
                           });
                       });
                   }else {
                       this.$message({
                           type: 'error',
                           message: '密码不正确'
                       });
                   }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },
            getList() {
                this.loading = true;
                getGrouponListApi(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.joinList = res.data.value.list;
                        this.formInline.recordsTotal = res.data.value.total;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getLink(customerId){
                let returnUrl = ''
                returnUrl = `${window.location.origin}/#/usersystem/detail/${customerId}`
                return returnUrl
            },
            getOrderLink(orderMainNo){
                let returnUrl = ''
                returnUrl = `${window.location.origin}/#/queryorder?orderMainNo=${orderMainNo}`
                return returnUrl
            },
            handleEdit(row){
                this.showCreate = true;
                this.getSelect(row)
            },
            getSelect(row){
                this.form= {
                    "activeNo": row.activeNo,
                    "inviteId":row.inviteId,
                    "bindCode": row.bindCode,
                    "orderType": row.orderType,
                    "sourceType": row.sourceType,
                    "platformId": row.platformId,
                    "groupType": row.groupType,
                    "address": row.address,
                    "isPrize":row.isPrize,
                    "limitOrderAmout": row.limitOrderAmout,
                    "limitSuccAmout": row.limitSuccAmout,
                    "groupName": row.groupName
                }
            },
            getInviteDetail(row){
                console.log('查看用户邀请记录:' + row)
                //查看邀请明细
                this.loading = true;
                this.showDialog = true;
                this.getSelect(row)
                getGrouponDtailList({"inviteId": row.inviteId}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.inviteList = res.data.value.list;
                        if (row.groupType == 1) {
                            for (let i of this.inviteList) {
                                i.sourceNickName = row.nickName;
                                i.orderMainNoUrl = '//erpnew.lechun.cc/admin_sold_show.html?SOLD_ID=' + i.orderMainNo;
                            }
                        }
                        console.log(this.inviteList);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            exportOrder(){
                window.open(`${downloadJoinOrder}?inviteId=${this.form.inviteId}&pageSize=99999&currentPage=1&pageRouterUrl=groupOrder`)
            },
            getLinkList(row){
                this.showDistributorVo=true;
                console.log('查看记录:' + row)
                this.loading = true;
                getLink({"inviteId": row.inviteId}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.distributorVoList = res.data.value.list;
                        console.log(this.distributorVoList);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            newGroupHandle(){
                this.showCreate = true;
                this.form= {
                    "activeNo": '',
                        "inviteId":'',
                        "bindCode": this.$route.query.bindCode || '',
                        "orderType": 1,
                        "sourceType": 2,
                        "platformId": 4,
                        "groupType": 2,
                        "address": '',
                        "isPrize":0,
                        "limitOrderAmout": 100,
                        "limitSuccAmout": 4000,
                        "groupName": ''
                }
            },
            saveGroup(){
                this.loading = true;
                creatGroup(this.form).then((res) => {
                    this.loading = false;
                    this.showCreate = false;
                    if (res.data.status == 200) {
                        this.getList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            startOrEndGroup(row){
                this.loading = true;
                row.isPrize=row.isPrize==1?0:1
                creatGroup(row).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.getList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },
            getUserDetailUrl(customerId){
                return '//erpnew.lechun.cc/mall_customer_edit.html?customerid=' + customerId;
                this.$router.push({path: '/userSystem/detail/:id', name: 'userSystemContent', params: {id: customerId}})
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/order/groupOrder.vue